import { useRef } from 'react'
import { useIsomorphicLayoutEffect } from '../../../core/hook/useIsomorphicLayout'
import { CustomCmsSeller } from '../../../domain/seller'
import { storeInformationGetMapEl } from './helpers'

const buildDirectionRouteBaidu = (
  seller: CustomCmsSeller,
  origin: { latitude: number; longitude: number },
) => {
  const urlBaidu = `https://api.map.baidu.com/direction?origin=latlng:${origin.latitude},${origin.longitude}|name:origin&destination=latlng:${seller.latitude},${seller.longitude}|name:destination&mode=driving&region=none&output=html`
  return urlBaidu
}

const buildMarkerRouteBaidu = (seller: CustomCmsSeller) => {
  const urlBaidu = `https://api.map.baidu.com/marker?location=${seller.latitude},${seller.longitude}&title=${seller.name}&output=html&src=webapp.baidu.openAPIdemo`
  return urlBaidu
}

const seeItinerary = (seller: CustomCmsSeller) => {
  navigator.geolocation.getCurrentPosition(
    (geolocationPosition) => {
      // if we have geo coordinates of user, redirect to baidu with directions API
      const { latitude, longitude } = geolocationPosition.coords
      const urlBaidupMap = buildDirectionRouteBaidu(seller, { latitude, longitude })
      window.open(urlBaidupMap)
    },
    () => {
      // if we don't have geo coordinates of user, redirect to baidu with marker of seller only
      const urlBaidupMap = buildMarkerRouteBaidu(seller)
      window.open(urlBaidupMap)
    },
  )
}

const initBaiduMarkerOnMap = (coords: { lat: number; lng: number }, map?: BMap.Map) => {
  const { lat, lng } = coords
  const point = new BMap.Point(Number(lng), Number(lat))

  const marker = new BMap.Marker(point, {
    icon: new BMap.Icon('/assets/img/map/marker/marker_01.png', new BMap.Size(40, 60)),
  })

  map?.addOverlay(marker)

  return marker
}

const useStoreInformationBaiduMap = (seller: CustomCmsSeller) => {
  // Baidu Map
  const mapRef = useRef<BMap.Map>()
  // Marker of seller on Baidu Map
  const markerSellerRef = useRef<BMap.Marker>()

  useIsomorphicLayoutEffect(() => {
    const mapEl = storeInformationGetMapEl()
    if (!mapEl) {
      return
    }

    if (!mapRef.current) {
      // Init Google Map
      mapRef.current = new BMap.Map(mapEl)
      const point = new BMap.Point(Number(seller.longitude), Number(seller.latitude))
      mapRef.current.centerAndZoom(point, 15)
      mapRef.current.enableScrollWheelZoom(true)

      // Init Marker on Google Map for Store
      markerSellerRef.current = initBaiduMarkerOnMap(
        {
          lat: Number(seller.latitude),
          lng: Number(seller.longitude),
        },
        mapRef.current,
      )
    }
  }, [seller])

  return { mapRef, seeItinerary, defaultIniteraryLink: buildMarkerRouteBaidu(seller) }
}

export default useStoreInformationBaiduMap
